import * as utils from './utils'

export function timeFormate(date) {
    if (!date) return '--'
    if (date == '-' || date == '') return '--'
    var dateTime = new Date()
    dateTime.setTime(date)
    var Y = dateTime.getFullYear();
    var M = dateTime.getMonth() + 1;
    M = M < 10 ? '0' + M : M;// 不够两位补充0
    var D = dateTime.getDate();
    D = D < 10 ? '0' + D : D;
    var H = dateTime.getHours();
    H = H < 10 ? '0' + H : H;
    var Mi = dateTime.getMinutes();
    Mi = Mi < 10 ? '0' + Mi : Mi;
    var S = dateTime.getSeconds();
    S = S < 10 ? '0' + S : S;
    return Y + '-' + M + '-' + D + ' ' + H + ':' + Mi + ':' + S;
}

export function formatEmptyValue(value) {
  if (value === '' || typeof value === 'undefined') {
    return '--'
  } else {
    return value
  }
};

/**
 * 金钱格式化，分直接格式成
 * @param {Number} money 金额
 * @param {Boolean} isFormateYuan 是否需要分转元
 * @return {string} 格式化后的金额
 */
export function formateMoney(money, isFormateYuan = true) {
  // console.log('formateMoney', money)
  if (Number(money) != money) {
    return money
  }
  // 格式化之前的数值
  let beforeFormateValue = money;
  return utils.amount_format_yuan(beforeFormateValue, isFormateYuan);
}
